import React from 'react';
import styled from 'styled-components';
import {Select} from 'components/antd';
import {MailCampaign, useMailCampaignsQuery} from 'api';
import useSearchParams from '../../useSearchParams';

const MailCampaignsFilter = () => {
  const {query, setQuery} = useSearchParams();

  const {data: {mailCampaigns: {mailCampaigns = []} = {}} = {}} =
    useMailCampaignsQuery({
      variables: {
        target: 'preleads',
        status: 'sent',
      },
    });

  return (
    <Select
      dropdownMatchSelectWidth={false}
      mode="multiple"
      allowClear
      value={query.mailCampaignIds}
      onChange={(value) => setQuery({mailCampaignIds: value})}>
      {mailCampaigns.map((option: MailCampaign) => (
        <StatusSelect.Option
          value={option.id}
          key={option.id}
          label={<React.Fragment>&nbsp; {option.title}</React.Fragment>}>
          &nbsp; {option.title}
        </StatusSelect.Option>
      ))}
    </Select>
  );
};

const StatusSelect = styled(Select)`
  &&& {
    min-width: 16px !important;
    margin-right: 8px;

    .ant-select-selector {
      padding: 0;
      border: none;
    }

    .ant-select-selection-item {
      padding: 0;
    }

    .ant-select-arrow {
      display: none;
    }
  }
`;

export default MailCampaignsFilter;
